import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { ROUTES } from '@/shared/constants/routes'
import MainLayout from '@/components/layout/MainLayout'

export default function PrivateRoute() {
  const { isAuthenticated, token } = useAuthStore()
  const location = useLocation()

  if (!token || !isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return <MainLayout />
}
